/* eslint no-console:0 */
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import 'vuetify/styles'
// MDI font is loaded from CDN with preload in layouts/_load_frontend.html.erb

import VueApexCharts from 'vue3-apexcharts'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueVideoWrapper from 'vue-video-wrapper'

import registerApp from '../helpers/register-app'

// Create Vuetify instance for Vue 3
export const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#1976D2',
          secondary: '#424242',
          accent: '#82B1FF',
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107',
        },
      },
      dark: {
        colors: {
          primary: '#1976D2',
          secondary: '#424242',
        },
      },
    },
  },
})

// Global components will be registered per-app in register-app.ts

import EditorApp from '../apps/editor'
import SchoolDesignPreview from '../apps/school-design-preview'
import ExamApp from '../apps/exam'
import ImportApp from '../apps/import'
import ClientApp from '../apps/client'
import ExamCreationFromStock from '../apps/exam_from_stock'
import ClientEmbed from '../apps/embed'


  ; (window as any).load_frontend = () => {
    registerApp(EditorApp)
    registerApp(SchoolDesignPreview)
    registerApp(ExamApp)
    registerApp(ImportApp)
    registerApp(ClientApp)
    registerApp(ClientEmbed)
    registerApp(ExamCreationFromStock)
  }